// extracted by mini-css-extract-plugin
module.exports = {"decrease":"decrease-3juHL","increase":"increase-2Xf8-","counter":"counter-2cOlD","counter_disabled":"counter_disabled-2G4XA"};